module.exports = __webpack_public_path__ + "static/media/check.88488f22.jpg";